import { Box } from '@chakra-ui/react';
import React from 'react';

import {
  VERTICAL_DIVIDER_COLOR,
  VERTICAL_DIVIDER_H,
  VERTICAL_DIVIDER_MX,
  VERTICAL_DIVIDER_W
} from '../../styles/tokens';

export type VerticalDividerProps = {
  /** Overrides the default `VERTICAL_DIVIDER_H`. A px/rem STRING, never a bare number (Chakra would
   *  resolve a number against its spacing scale). */
  readonly height?: string;
  /** Overrides the default `data-testid="vertical-divider"`. */
  readonly testId?: string;
};

/**
 * Reusable, purely decorative vertical rule between inline groups -- the thin rule between the
 * `patient-summary-info` chip's fields (`PatientSummaryBar`), and the one before the case-context
 * bar's right-pinned Routing Context. Chrome only: no config binding, no registry entry.
 * `aria-hidden` because it carries no meaning; `flexShrink={0}` keeps its 1px width from collapsing
 * in a tight row.
 */
export const VerticalDivider: React.FC<VerticalDividerProps> = ({
  height = VERTICAL_DIVIDER_H,
  testId = 'vertical-divider'
}) => (
  <Box
    as="span"
    aria-hidden="true"
    data-testid={testId}
    flexShrink={0}
    w={VERTICAL_DIVIDER_W}
    h={height}
    mx={VERTICAL_DIVIDER_MX}
    bg={VERTICAL_DIVIDER_COLOR}
  />
);
